export default __webpack_public_path__ + "static/media/head01_zh_cn_pc.c1830756.png";